import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Features } from '@ultrasnip/contracts';
import { SecurityPanel } from '@/features/security/password-panel';
import { PreferencesPanel } from '@/features/security/preferences-panel';
import { SessionsPanel } from '@/features/security/sessions-panel';
import { TwoFactorPanel } from '@/features/security/two-factor-panel';
import { authClient } from '@/lib/auth-client';
import { meQuery } from '@/lib/queries';

export const Route = createFileRoute('/_app/settings/account')({
  component: AccountScreen,
});

/** One left-aligned column under the Settings tabs. */
function AccountScreen() {
  const { data: me } = useSuspenseQuery(meQuery);
  const session = authClient.useSession();

  return (
    <div className="flex max-w-[46rem] flex-col gap-4">
      <PreferencesPanel me={me} />
      <SecurityPanel />
      {Features.twoFactor && <TwoFactorPanel enabled={me.user.twoFactorEnabled} />}
      {Features.deviceSessions && <SessionsPanel currentSessionId={session.data?.session.id ?? null} />}
    </div>
  );
}
